'use client';

// ═══════════════════════════════════════════════════════════════════════════
// PostHog DÉSACTIVÉ — conformité RGPD/ePrivacy (audit 2026-06-18)
//
// POURQUOI : la Politique de confidentialité (app/legal/privacy) garantit
// « aucun cookie de tracking, analytique ou publicitaire ». Charger PostHog
// (analytics + identify email) contredisait cette promesse → politique fausse +
// trackers chargés sans consentement opt-in (Directive ePrivacy 2002/58/CE).
//
// Décision : retirer l'analytics. Aucun tracker, aucun appel réseau tiers,
// aucune donnée personnelle envoyée. La politique redevient exacte.
//
// Pour RÉACTIVER un jour : il faudra D'ABORD une vraie bannière de consentement
// opt-in (avant tout chargement) ET réécrire la politique. Ne pas se contenter
// de remettre l'init ici.
// ═══════════════════════════════════════════════════════════════════════════

export default function PostHogProvider({ children }) {
  return children;
}
